<template>
  <div
    :class="['cf-header-logo', { 'cf-cursor-pointer': logoNavigation.isClickable }]"
    @click="singleClickHandler"
    @dblclick="doubleClickHandler"
  >
    <template v-if="merchant.options.logoUrl">
      <span
        class="cf-header-logo__image"
        :style="{ 'background-image': `url(${merchant.options.logoUrl})` }"
      />

      <span class="ada-text">
        {{ merchant.name }}
      </span>
    </template>

    <h1
      v-else
      class="cf-header-logo__text"
    >
      {{ merchant.name }}
    </h1>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'Logo',

    props: {
      logoNavigation: {
        type: Object,
        default() {
          return {
            isClickable: true,
            route: 'orderMenu'
          };
        }
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    },

    methods: {
      singleClickHandler(event) {
        if (!this.logoNavigation.isClickable) {
          return;
        }

        const defaultRoute = {
          name: this.logoNavigation.route,
          params: { merchantId: this.$route.params.merchantId }
        };

        if (event.metaKey || event.ctrlKey) {
          const routeData = this.$router.resolve(defaultRoute);

          window.open(routeData.href, '_blank');
        }

        else if (this.$route.name !== 'orderMenu') {
          this.$router.push(defaultRoute);
        }
      },

      doubleClickHandler() {
        if (this.isLogoNavigationDisabled) {
          return;
        }

        this.$store.dispatch('menu/selectMenuType', 'secret');
      }
    }
  };
</script>
